// import Account from "@/helper/AccountHelper.js";
import ConfigManager from '@/config/ConfigManager.js';
import BzbsApi from '@/core/Http/BzbsApi.js';
import { map } from 'rxjs/operators';
import { AccountModel } from "../model/AccountModel.js";
import { AccessKeyModel } from '../model/AccessKeyModel.js';

/**
 * @method apiRequestOTP
 * @method apiLogin
 * @method apiLogout
 * @method apiLoginLine
 * @method apiLoginDevice
 * @method apiReLoginDevice
 */
export default {
    /**
     * @param {AuthLoginConfigModel} params /core/Account/config/AuthConfigModel.js
     */
    apiLogin: function (params) {
        const url = ConfigManager.getApiUrl() + '/auth/bzbs_login';
        // let url = 'http://localhost:3000/auth/bzbs_login';
        return BzbsApi.connectBzbsPost(url, null, params)
            .pipe(map((res) => {
                let accountModel = new AccountModel();
                accountModel.setDataFromApi(res.data);
                return accountModel;
            }));
    },

    /**
     * @param {String} token
     * @param {String} strFBToken
     * @param {String} strUUID
     */
    apiLogout: function (token, FacebookToken, uuid) {
        const params = {
            uuid: uuid,
            access_token: FacebookToken,
        };

        const url = ConfigManager.getApiUrl() + '/auth/logout';
        return BzbsApi.connectBzbsPost(url, token, params).pipe(map((res) => {
            return res.data;
        }));
    },

    /**
     * @param {string} lineIdToken
     */
    apiLoginLine: function (lineIdToken) {
        const params = {
            app_id: ConfigManager.getAppId(),
            id_token: lineIdToken,
        };
        const url = ConfigManager.getApiUrl() + '/auth/line_login';
        return BzbsApi.connectBzbsPost(url, null, params).pipe(map((res) => {
            let accountModel = new AccountModel();
            accountModel.setDataFromApi(res.data);
            return accountModel;
            // return res.data;
        }));
    },

    /**
     * @param {authDeviceLoginConfigModel} params /core/Account/model/AuthConfigModel.js
     */
    apiLoginDevice: function (params) {
        params.app_id = ConfigManager.getAppId();

        const url = ConfigManager.getApiUrl() + '/auth/device_login';
        return BzbsApi.connectBzbsPost(url, null, params).pipe(map((res) => {
            //return res.data;
            let accountModel = new AccountModel();
            accountModel.setDataFromApi(res.data);
            return accountModel;
        }));
    },

    /**
     * Resume Login
     * @param {string } token
     * @param {Object} uuid  // store in cache user
     */
    apiReLoginDevice: function (token, uuid) {
        const params = {
            uuid: uuid,
            app_id: ConfigManager.getAppId(),
            os: "web",
            platform: "web",
            mac_address: uuid,
            // device_noti_enable: data.isDeviceNotiEnable,
            // client_version: data.strClientVersion,
        };

        const url = ConfigManager.getApiUrl() + '/auth/device_resume';
        return BzbsApi.connectBzbsPost(url, token, params).pipe(map((res) => {
            console.log('res', res.data)

            return res.data;
        }));
    },

    //#region access key
    /**
     * Create AccessKey for send to another website
     * @param {String} payload Payload for keep value, string json format
     */
    apiCreateAccessKey: function (token, payload) {
        let params = {
            data: payload
        }
        let url = ConfigManager.getApiUrl() + '/setting'
        return BzbsApi.connectBzbsPost(url, token, params).pipe(map((res) => {
            let accessKey = new AccessKeyModel()
            accessKey.setDataFromApi(res.data.data)
            return accessKey
        }))
    },
    /**
     * @param {string} accessKey
     */
    apiReadAccessKey: function (accessKey) {
        let url = ConfigManager.getApiUrl() + '/setting/' + accessKey
        return BzbsApi.connectBzbsGet(url, null, null).pipe(map((res) => {
            return res.data
        }))
    },
    //#endregion
}
